enum ExercisePrivacy {
	Private = "private",
	PublicToOrganisation = "public_to_organisation",
	Public = "public",
}

export default ExercisePrivacy;
